// Stabilization directive for the migration build.
// Replaces the Vue 2-only background-image usage of vue-lazyload.

function normalizeUrl(value) {
    return value == null ? '' : String(value);
}

function quoteUrl(url) {
    return url.replace(/"/g, '\\"');
}

function applyLazyValue(el, binding) {
    const url = normalizeUrl(binding.value);

    if (binding.arg === 'background-image' || el.tagName !== 'IMG') {
        el.style.backgroundImage = url ? `url("${quoteUrl(url)}")` : '';
        return;
    }

    if (url) {
        el.setAttribute('src', url);
    } else {
        el.removeAttribute('src');
    }
}

export default {
    beforeMount: applyLazyValue,
    mounted: applyLazyValue,
    updated(el, binding) {
        if (binding.value !== binding.oldValue) {
            applyLazyValue(el, binding);
        }
    },
};
